.summary {
  min-width: 0;
}

.scoreCard {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: var(--shadow-close);
  display: grid;
  gap: 24px;
  grid-template-columns: minmax(0, 200px) minmax(0, 1fr);
  padding: 24px;
}

.total {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
}

.totalLabel {
  font-family: var(--font-family-heading);
  font-size: 1.5rem;
  margin: 8px 0 4px;
}

.small {
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
  margin: 0 0 4px;
}

.categories {
  list-style: none;
  margin: 0;
  padding: 0;
}

.category {
  align-items: flex-start;
  border-bottom: 1px solid var(--color-muted);
  display: flex;
  gap: 16px;
  padding: 12px 0;
}

.category:last-child {
  border-bottom: none;
}

.categoryText {
  min-width: 0;
}

.categoryName {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-weight: 600;
  gap: 8px;
  margin: 0 0 4px;
}

.streak {
  background: var(--color-cta);
  border-radius: 999px;
  color: var(--color-primary-deep);
  font-size: 0.75rem;
  font-weight: 600;
  padding: 2px 10px;
}

.note {
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
  margin: 12px 0 0;
}

.block {
  margin-top: 2rem;
}

.blockHeading {
  font-family: var(--font-family-heading);
  font-size: 1.5rem;
  margin: 0 0 12px;
}

.messages {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.message {
  background: #ffffff;
  border-radius: 12px;
  margin: 0;
  padding: 16px 20px;
}

.message p {
  margin: 0 0 8px;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.message footer {
  color: var(--color-text-muted);
  font-size: var(--font-size-small);
}

@media (max-width: 599px) {
  .scoreCard,
  .messages {
    grid-template-columns: minmax(0, 1fr);
  }
}
